// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetContext, ActionSheetV2, LgPadding } from '@alto/design-system';
import { AddPaymentCard } from '@alto/features';
import React, { useContext } from 'react';

export type Props = {
  readonly onClose?: () => void;
};

export function CreditCardActionSheet({ onClose: handleClose }: Props) {
  const { closeActionSheet } = useContext(ActionSheetContext);
  const onClose = handleClose ?? closeActionSheet;

  return (
    <ActionSheetV2
      title="Add new card"
      handleClose={onClose}
      analyticsName="credit card"
    >
      {/* The sheet title already carries its own bottom padding - skip the top of
          this LgPadding so the form sits closer to the header. */}
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <AddPaymentCard onClose={onClose} />
      </LgPadding>
    </ActionSheetV2>
  );
}
